var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRealwear = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M13.1 19.4c-.3 0-.5-.2-.5-.5v-3.7c0-.3.2-.5.5-.5s.5.2.5.5v3.7c0 .3-.2.5-.5.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#129BF9",
  d: "M22.9 19.4c-.3 0-.5-.2-.5-.5v-1.2h-3.6c-.6 0-1.1-.5-1.1-1.1v-.3c0-.6.5-1.1 1.1-1.1h3.6c.5 0 .9.4.9.8v2.8c.1.4-.1.6-.4.6m-4-3.1c-.1 0-.1 0-.1.1v.3s0 .1.1.1h3.6v-.5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M2.8 19.1c-.3 0-.5-.2-.5-.5v-2.5c0-.5.4-.8.9-.8h1.9c.3 0 .5.2.5.5s-.2.5-.5.5H3.3v2.3c0 .3-.2.5-.5.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M1.1 15.3H.9c-.3-.1-.4-.4-.3-.6l3-7.9c.4-.9 1.2-1.4 2-1.3.4 0 .7.2.9.4s.2.5 0 .7-.5.2-.7 0c-.1-.1-.2-.1-.3-.1-.3 0-.7.2-.9.6l-3 7.9c-.1.1-.3.3-.5.3M24.9 15.3c-.2 0-.4-.1-.5-.3l-3-7.9c-.1-.4-.5-.6-.9-.6-.1 0-.2.1-.3.1-.2.2-.5.2-.7 0s-.2-.5 0-.7.6-.4.9-.4c.8-.1 1.6.4 1.9 1.2l3 7.9q.15.45-.3.6c0 .1-.1.1-.1.1"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M18.2 20.5c-2.7 0-4.6-.8-5.1-1.1-5.3 2.3-9.6.4-10.4 0h-.9c-.6 0-1.2-.5-1.2-1.2V15c0-1 .8-1.7 1.7-1.7h21.3c1 0 1.7.8 1.7 1.7v3c0 .8-.6 1.4-1.4 1.4h-.5c-1.9.8-3.6 1.1-5.2 1.1M2.4 14.3c-.4 0-.7.3-.7.7v3.2c0 .1.1.2.2.2H3l.1.1s4.4 2.3 9.7 0h.5l.1.1s4.4 2.3 9.7 0h.9c.2 0 .4-.2.4-.4v-3c0-.4-.3-.7-.7-.7H2.4z"
})));
export default SvgRealwear;